import React from "react";
import { useActor } from "@xstate/react";
import { State } from "xstate";
import { styled } from "@iventis/styles";
import { PermissionsEditComponent } from "@iventis/permissions/src/permissions-edit";
import { PermissionContext } from "@iventis/permissions/src/permissions-edit.machine";
import { PERM_MACHINE_ID } from "./edit-schedule.machine";

interface StateWithPermissions {
    permissions: PermissionContext;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ScheduleEditPermissionsComponent: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentState: State<StateWithPermissions, any, any, any, any>;
}> = ({ parentState }) => {
    const [state, send] = useActor(parentState.children[PERM_MACHINE_ID]);
    return <StyledPermissions state={state} send={send} />;
};

const StyledPermissions = styled(PermissionsEditComponent)`
    .permissionsContainer {
        overflow-y: visible;
    }
`;
